import CustomQuerySetupWizardApiMetricBuilderStepCommonComponent from 'webapp/components/custom-query/setup/wizard/api-metric-builder/step-common';

export default class CustomQuerySetupWizardApiMetricBuilderStepMetricComponent extends CustomQuerySetupWizardApiMetricBuilderStepCommonComponent {
	override stepTitle = 'Select a metric value';
	override stepDescription =
		"Select a property that includes the metric value you'd like to track. In other words, choose the line that you want your metric to measure. A metric value must be purely numeric. Want to measure more than this metric? Select one for now — you will be able to create additional metrics later.";
}
